"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EdenAuth = exports.SessionState = exports.RequestError = void 0;
var callback_holder_1 = require("./callback-holder");
var defaults_1 = require("./defaults");
var eden_auth_1 = require("./eden-auth");
var crypto_utils_1 = require("./eden-auth/crypto-utils");
var encrypted_store_1 = require("./encrypted-store");
var recaptcha_1 = require("./recaptcha");
var token_refresher_1 = require("./token-refresher");
var utils_1 = require("./utils");
var eden_auth_2 = require("./eden-auth");
Object.defineProperty(exports, "RequestError", { enumerable: true, get: function () { return eden_auth_2.RequestError; } });
var SessionState;
(function (SessionState) {
    /// No auth session active
    SessionState["none"] = "none";
    /// Session has tokens but expires and need refresh
    SessionState["unavailable"] = "unavailable";
    /// Session is active
    SessionState["active"] = "active";
})(SessionState || (exports.SessionState = SessionState = {}));
var EdenAuth = /** @class */ (function () {
    function EdenAuth(edenURL, recaptchaSiteKey, clientAuthKey, tokenStore, options) {
        var _this = this;
        this.edenURL = edenURL;
        this.recaptchaSiteKey = recaptchaSiteKey;
        this.options = options;
        this.pendingState = null;
        this.clientToken = null;
        this.refreshCallbackWaiters = new callback_holder_1.CallbackHolder();
        var _a = clientAuthKey.split(':'), clientId = _a[0], clientKey = _a[1];
        this.tokenRefresher = new token_refresher_1.TokenRefresher(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, this.refreshTokenIfNeeded()];
        }); }); });
        this.tokenStore = new encrypted_store_1.EncryptedStore(tokenStore, options === null || options === void 0 ? void 0 : options.storageKey);
        this.api = new eden_auth_1.AuthApi(this.edenURL, this.recaptchaSiteKey, clientId, clientKey);
    }
    Object.defineProperty(EdenAuth.prototype, "sessionState", {
        get: function () {
            if (!this.authTokens || this.authTokens.refreshToken.expires < (0, utils_1.getTimestamp)()) {
                return SessionState.none;
            }
            return this.authTokens.accessToken === undefined || this.authTokens.accessToken.expires < (0, utils_1.getTimestamp)()
                ? SessionState.unavailable
                : SessionState.active;
        },
        enumerable: false,
        configurable: true
    });
    EdenAuth.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadState()];
                    case 1:
                        _a.sent();
                        this.tokenStore.registerChangeNotifier(function () {
                            _this.loadState()
                                .then(function () { return _this.scheduleRefresh(); })
                                .catch();
                        });
                        return [4 /*yield*/, this.scheduleRefresh(true)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EdenAuth.prototype.onInvalidAccessToken = function (callback) {
        return __awaiter(this, void 0, void 0, function () {
            var shouldAttemptInvalidation, timeFromLastAttempt, updated;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shouldAttemptInvalidation = !this.refreshCallbackWaiters.hasCallbacks;
                        this.refreshCallbackWaiters.add(callback);
                        if (!shouldAttemptInvalidation) return [3 /*break*/, 5];
                        timeFromLastAttempt = this.tokenRefresher.timeFromLastRefreshAttempt;
                        if (timeFromLastAttempt !== undefined &&
                            timeFromLastAttempt < defaults_1.MINIMUM_TIME_BETWEEN_FAILED_REFRESHES_IN_SECONDS) {
                            return [2 /*return*/, this.refreshCallbackWaiters.invokeAndRemove({ success: false })];
                        }
                        return [4 /*yield*/, this.tokenStore.atomicUpdate(function (state) {
                                var _a;
                                if ((_a = state === null || state === void 0 ? void 0 : state.tokens) === null || _a === void 0 ? void 0 : _a.accessToken) {
                                    return __assign(__assign({}, state), { tokens: {
                                            refreshToken: state.tokens.refreshToken,
                                        } });
                                }
                            })];
                    case 1:
                        updated = (_a.sent()).updated;
                        if (!updated) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.tokenRefresher.refreshImmediately()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.tokenRefresher.refreshDeadlineInSeconds(defaults_1.ACCESS_TOKEN_REFRESH_FALLBACK_TIME_IN_SECONDS)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    EdenAuth.prototype.refreshTokenIfNeeded = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var secondsRemaining, refreshToken, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: 
                    // Load state before attempting to refresh as a different tab may have refreshed already, and we somehow missed
                    //  the notification
                    return [4 /*yield*/, this.loadState()];
                    case 1:
                        // Load state before attempting to refresh as a different tab may have refreshed already, and we somehow missed
                        //  the notification
                        _c.sent();
                        if (!((_a = this.authTokens) === null || _a === void 0 ? void 0 : _a.refreshToken)) return [3 /*break*/, 10];
                        secondsRemaining = this.authTokens.accessToken === undefined ? 0 : this.authTokens.accessToken.expires - (0, utils_1.getTimestamp)();
                        if (!(secondsRemaining <= defaults_1.ACCESS_TOKEN_REFRESH_BEFORE_EXPIRATION_IN_SECONDS)) return [3 /*break*/, 10];
                        refreshToken = this.authTokens.refreshToken;
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 5, , 10]);
                        return [4 /*yield*/, this.refreshTokens(refreshToken)];
                    case 3:
                        _c.sent();
                        return [4 /*yield*/, this.refreshCallbackWaiters.invokeAndRemove({ success: true })];
                    case 4:
                        _c.sent();
                        return [3 /*break*/, 10];
                    case 5:
                        e_1 = _c.sent();
                        if (!(e_1 instanceof eden_auth_1.RequestError && e_1.code === 401)) return [3 /*break*/, 7];
                        // 401 means that our session has ended, but maybe in between we got a new session
                        //  so we reload the state and check that it is the same refresh token and logout if
                        // it is. Otherwise, we throw the error and let the retry logic to kick in
                        return [4 /*yield*/, this.loadState()];
                    case 6:
                        // 401 means that our session has ended, but maybe in between we got a new session
                        //  so we reload the state and check that it is the same refresh token and logout if
                        // it is. Otherwise, we throw the error and let the retry logic to kick in
                        _c.sent();
                        if (refreshToken.data === ((_b = this.authTokens) === null || _b === void 0 ? void 0 : _b.refreshToken.data)) {
                            return [2 /*return*/, this.logOut()];
                        }
                        _c.label = 7;
                    case 7: return [4 /*yield*/, this.refreshCallbackWaiters.invokeAndRemove({ success: false })];
                    case 8:
                        _c.sent();
                        return [4 /*yield*/, this.tokenStore.atomicUpdate(function (state) { return state; })];
                    case 9:
                        _c.sent();
                        throw e_1;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    EdenAuth.prototype.refreshTokens = function (refreshToken) {
        return __awaiter(this, void 0, void 0, function () {
            var tokens;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.refreshTokens(refreshToken)];
                    case 1:
                        tokens = _a.sent();
                        if (!tokens) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.setupTokens(tokens)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.logOut()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    EdenAuth.prototype.scheduleRefresh = function (onStartup) {
        var _a, _b;
        if (onStartup === void 0) { onStartup = false; }
        return __awaiter(this, void 0, void 0, function () {
            var secondsRemaining;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!((_a = this.authTokens) === null || _a === void 0 ? void 0 : _a.accessToken)) return [3 /*break*/, 2];
                        secondsRemaining = this.authTokens.accessToken.expires -
                            (0, utils_1.getTimestamp)() -
                            defaults_1.ACCESS_TOKEN_REFRESH_BEFORE_EXPIRATION_IN_SECONDS;
                        this.tokenRefresher.refreshDeadlineInSeconds(secondsRemaining);
                        return [4 /*yield*/, this.refreshCallbackWaiters.invokeAndRemove({ success: true })];
                    case 1:
                        _c.sent();
                        return [3 /*break*/, 6];
                    case 2:
                        if (!((_b = this.authTokens) === null || _b === void 0 ? void 0 : _b.refreshToken)) return [3 /*break*/, 4];
                        this.tokenRefresher.refreshDeadlineInSeconds(onStartup ? 0 : defaults_1.ACCESS_TOKEN_REFRESH_MAX_BACKOFF_TIME_IN_SECONDS);
                        return [4 /*yield*/, this.refreshCallbackWaiters.invokeAndRemove({ success: false })];
                    case 3:
                        _c.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        this.tokenRefresher.cancel();
                        return [4 /*yield*/, this.refreshCallbackWaiters.invokeAndRemove({ success: false })];
                    case 5:
                        _c.sent();
                        _c.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    EdenAuth.prototype.setupTokens = function (tokens) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.authTokens = tokens;
                        return [4 /*yield*/, this.saveState()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.scheduleRefresh()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Request an email with authentication token to the API
     *
     * @param email
     * @param redirectLink if given, will cause the generated login email to have a login link that will take the user to redirectLink
     */
    EdenAuth.prototype.requestAuthenticationEmail = function (email, redirectLink) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.requestAuthenticationEmail(email, redirectLink)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EdenAuth.prototype.logInWithToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var tokens;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.loginWithToken(token)];
                    case 1:
                        tokens = _a.sent();
                        if (!tokens) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.setupTokens(tokens)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, tokens.accessToken.data];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EdenAuth.prototype.requestForgotPasswordToken = function (email, redirectLink, callbacks) {
        return __awaiter(this, void 0, void 0, function () {
            var clientToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.requestForgotPasswordToken(email, redirectLink, callbacks)];
                    case 1:
                        clientToken = _a.sent();
                        return [2 /*return*/, clientToken];
                }
            });
        });
    };
    EdenAuth.prototype.changePassword = function (newPassword, clientToken, redirectLink, callbacks) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.requestChangePassword(newPassword, clientToken, redirectLink, callbacks)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EdenAuth.prototype.startLoginOrRegistration = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, response, token;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.api.startLoginOrRegistration(email)];
                    case 1:
                        _a = _b.sent(), response = _a.response, token = _a.token;
                        this.pendingState = response;
                        this.clientToken = token;
                        if (response.type === 'user-action-required') {
                            if (response.reason === 'registration') {
                                return [2 /*return*/, 'registration-required'];
                            }
                            return [2 /*return*/, response.kind];
                        }
                        return [2 /*return*/, response.type];
                }
            });
        });
    };
    EdenAuth.prototype.finishLogInWithEmail = function (_a) {
        var password = _a.password, code = _a.code, callbacks = _a.callbacks;
        return __awaiter(this, void 0, void 0, function () {
            var state, token, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.pendingState) return [3 /*break*/, 3];
                        state = this.pendingState;
                        token = this.clientToken;
                        return [4 /*yield*/, this.api.finishLogInWithEmail({ state: state, token: token, password: password, code: code, callbacks: callbacks })];
                    case 1:
                        response = _b.sent();
                        return [4 /*yield*/, this.sharedResponseLogic(response)];
                    case 2: return [2 /*return*/, _b.sent()];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EdenAuth.prototype.finishRegistration = function (_a) {
        var password = _a.password, code = _a.code, firstName = _a.firstName, lastName = _a.lastName, callbacks = _a.callbacks;
        return __awaiter(this, void 0, void 0, function () {
            var state, token, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.pendingState) return [3 /*break*/, 3];
                        state = this.pendingState;
                        token = this.clientToken;
                        return [4 /*yield*/, this.api.finishRegistration({
                                state: state,
                                token: token,
                                code: code,
                                password: password,
                                firstName: firstName,
                                lastName: lastName,
                                callbacks: callbacks,
                            })];
                    case 1:
                        response = _b.sent();
                        return [4 /*yield*/, this.sharedResponseLogic(response)];
                    case 2: return [2 /*return*/, _b.sent()];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EdenAuth.prototype.provideMFAVerificationCode = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var state, tokens;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.pendingState) return [3 /*break*/, 3];
                        state = this.pendingState;
                        this.pendingState = null;
                        return [4 /*yield*/, this.api.provideMFAVerificationCode(state, code)];
                    case 1:
                        tokens = _a.sent();
                        if (!tokens) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.setupTokens(tokens)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, 'logged-in'];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EdenAuth.prototype.logOut = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var refreshToken;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.tokenRefresher.cancel();
                        refreshToken = (_a = this.authTokens) === null || _a === void 0 ? void 0 : _a.refreshToken;
                        this.authTokens = undefined;
                        return [4 /*yield*/, this.saveState()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.refreshCallbackWaiters.invokeAndRemove({ success: false })];
                    case 2:
                        _b.sent();
                        if (!refreshToken) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.api.logOut(refreshToken)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    EdenAuth.prototype.getAuthHeaders = function () {
        if (this.authTokens && this.authTokens.accessToken) {
            return {
                'gc-token': this.authTokens.accessToken.data,
                'gc-device-id': this.deviceId,
            };
        }
        return {
            'gc-device-id': this.deviceId,
        };
    };
    EdenAuth.prototype.setRecaptcha = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, recaptcha_1.initRecaptcha)(this.recaptchaSiteKey)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EdenAuth.prototype.removeRecaptcha = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, recaptcha_1.removeRecaptcha)()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EdenAuth.prototype.loadState = function () {
        return __awaiter(this, void 0, void 0, function () {
            var state, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.tokenStore.load()];
                    case 1:
                        state = _a.sent();
                        if (state) {
                            if (state.deviceId) {
                                this.deviceId = state.deviceId;
                                this.api.setDeviceId(this.deviceId);
                            }
                            this.authTokens = state.tokens;
                        }
                        else {
                            this.authTokens = undefined;
                            this.generateDeviceIdIfNeeded();
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EdenAuth.prototype.saveState = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.generateDeviceIdIfNeeded();
                        return [4 /*yield*/, this.tokenStore.store({
                                version: 1,
                                tokens: this.authTokens,
                                deviceId: this.deviceId,
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_3 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EdenAuth.prototype.generateDeviceIdIfNeeded = function () {
        if (!this.deviceId) {
            this.deviceId = randomDeviceId();
            this.api.setDeviceId(this.deviceId);
        }
    };
    EdenAuth.prototype.sharedResponseLogic = function (response) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (response.type === 'user-action-required' && response.kind === 'mfa') {
                            this.pendingState = response;
                            return [2 /*return*/, 'mfa'];
                        }
                        if (!(response.type === 'logged-in')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setupTokens(response.tokens)];
                    case 1:
                        _a.sent();
                        this.pendingState = null;
                        this.clientToken = null;
                        return [2 /*return*/, 'logged-in'];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return EdenAuth;
}());
exports.EdenAuth = EdenAuth;
var randomDeviceId = function () { return crypto_utils_1.CryptoUtils.toHex(crypto_utils_1.CryptoUtils.randomBytes(16)); };
